import { v4 as uuidv4 } from 'uuid';

export const breadCrumbData = [
  {
    id: uuidv4(),
    title: 'Travel Home',
    link: 'https://www.makemytrip.com'
  },
  {
    id: uuidv4(),
    title: 'Kumbh Mela',
    link: 'https://www.makemytrip.com/railways/kumbh-mela.html'
  }
];

export const aboutKumbhData = {
  title: 'About Kumbh Mela 2021',
  description:
    'The next Kumbh Mela will be held in 2021 in Haridwar, a religious event which will be attended by millions of devotees around the world. The Kumbh Mela is held at one of the four holy pilgrimage destinations, Haridwar, Nashik, Allahabad and Ujjain, every 12 years by rotation. The dates for a pilgrimage to the Kumbh Mela are determined according to the Vikram Samvat calendar. At the Kumbh Mela Haridwar, millions of people will gather to take a dip in the holy River Ganges. The dates for the Kumbh Mela 2021 have been announced. Kumbh Mela 2021 will begin on 14th January, on the auspicious occasion of Makar Sankranti. The first Shahi Snan will take place on 11th March, and the second and third ones on 12 and 14th April respectively. The fourth Shahi Snan will be held on 27th April, and on the same day, the Haridwar Kumbh Mela 2021 will come to an end.'
};

export const bathingDateData = [
  {
    id: uuidv4(),
    date: '11 Mar 2021',
    occasion: 'Maha Shivratri'
  },
  {
    id: uuidv4(),
    date: '12 Apr 2021 ',
    occasion: 'Somvati amavasya'
  },
  {
    id: uuidv4(),
    date: '14 Apr 2021',
    occasion: 'Mesh sankraanti & Baisakhi'
  },
  {
    id: uuidv4(),
    date: '27 Apr 2021',
    occasion: 'Chaitra Poornima'
  }
];

export const doData = {
  heading: 'DO’s',
  theme: 'green',
  listData: [
    {
      id: uuidv4(),
      iconUrl: 'kumbhMelaDosIcon',
      text: 'Please follow all the guidelines for COVID-19 issued by WHO, Govt. of India, Govt. of Uttarakhand and various related Govt. Agencies.'
    },
    {
      id: uuidv4(),
      iconUrl: 'kumbhMelaDosIcon',
      text: 'Please wear a mask at all times.'
    },
    {
      id: uuidv4(),
      iconUrl: 'kumbhMelaDosIcon',
      text: 'Please follow COVID Appropriate Behaviours.'
    },
    {
      id: uuidv4(),
      iconUrl: 'kumbhMelaDosIcon',
      text: 'Please visit the website regarding various information related to the Kumbh Mela.'
    },
    {
      id: uuidv4(),
      iconUrl: 'kumbhMelaDosIcon',
      text: 'Keep Emergency Contact numbers handy at all times.'
    },
    {
      id: uuidv4(),
      iconUrl: 'kumbhMelaDosIcon',
      text: 'Use Bathing Ghats that are authorized by the Mela administration only and that are nearest to place of stay in the Mela area.'
    },
    {
      id: uuidv4(),
      iconUrl: 'kumbhMelaDosIcon',
      text: 'Inform the authorities if any unidentified or suspicious object/activity is found.'
    },
    {
      id: uuidv4(),
      iconUrl: 'kumbhMelaDosIcon',
      text: 'Follow the instructions given by the Mela Administration through PA System or any other modes.'
    },
    {
      id: uuidv4(),
      iconUrl: 'kumbhMelaDosIcon',
      text: 'Cooperate with the Departments involved in organizing the Mela.'
    },
    {
      id: uuidv4(),
      iconUrl: 'kumbhMelaDosIcon',
      text: 'Reach out to the Lost and Found Centres for loss of loved ones and belongings.'
    }
  ]
};

export const donotData = {
  heading: 'DON’ts',
  theme: 'red',
  listData: [
    {
      id: uuidv4(),
      iconUrl: `kumbhMelaDontsIcon`,
      text: 'Don’t pollute the river Ganga by using soaps, detergents or by disposing Pujan Samagri into the holy river.'
    },
    {
      id: uuidv4(),
      iconUrl: `kumbhMelaDontsIcon`,
      text: 'Don’t carry too much baggage while travelling and avoid carrying valuables.'
    },
    {
      id: uuidv4(),
      iconUrl: `kumbhMelaDontsIcon`,
      text: 'Don’t use plastic bags in the city and mela area.'
    },
    {
      id: uuidv4(),
      iconUrl: `kumbhMelaDontsIcon`,
      text: 'Don’t defecate in the open.'
    },
    {
      id: uuidv4(),
      iconUrl: `kumbhMelaDontsIcon`,
      text: 'Don’t trust strangers offering something to eat in the name of Prasad.'
    },
    {
      id: uuidv4(),
      iconUrl: `kumbhMelaDontsIcon`,
      text: 'Don’t go to crowded places if suffering from contagious disease'
    },
    {
      id: uuidv4(),
      iconUrl: `kumbhMelaDontsIcon`,
      text: 'Don’t venture into the waters beyond permissible limits'
    },
    {
      id: uuidv4(),
      iconUrl: `kumbhMelaDontsIcon`,
      text: 'Don’t get into unnecessary conflicts'
    }
  ]
};

export const topRoutesData = [
  {
    id: uuidv4(),
    heading: 'Top Cabs  Routes to Haridwar',
    listData: [
      {
        id: uuidv4(),
        text: 'Cabs From Delhi To Haridwar',
        link: 'https://www.makemytrip.com/car-rental/delhi-haridwar-cab-services.html'
      },
      {
        id: uuidv4(),
        text: 'Cabs From Dehradun To Haridwar',
        link: 'https://www.makemytrip.com/car-rental/dehradun-haridwar-cab-services.html'
      },
      {
        id: uuidv4(),
        text: 'Cabs From Chandigarh To Haridwar',
        link: 'https://www.makemytrip.com/car-rental/chandigarh-haridwar-cab-services.html'
      },
      {
        id: uuidv4(),
        text: 'Cabs From Ghaziabad To Haridwar',
        link: 'https://www.makemytrip.com/car-rental/ghaziabad-haridwar-cab-services.html'
      },
      {
        id: uuidv4(),
        text: 'Cabs From Noida To Haridwar',
        link: 'https://www.makemytrip.com/car-rental/noida-haridwar-cab-services.html'
      },
      {
        id: uuidv4(),
        text: 'Cabs From Faridabad To Haridwar',
        link: 'https://www.makemytrip.com/car-rental/faridabad-haridwar-cab-services.html'
      },
      {
        id: uuidv4(),
        text: 'Cabs From Gurgaon To Haridwar',
        link: 'https://www.makemytrip.com/car-rental/gurgaon-haridwar-cab-services.html'
      },
      {
        id: uuidv4(),
        text: 'Cabs From Ambala To Haridwar',
        link: 'https://www.makemytrip.com/car-rental/ambala-haridwar-cab-services.html'
      },
      {
        id: uuidv4(),
        text: 'Cabs From Jaipur To Haridwar',
        link: 'https://www.makemytrip.com/car-rental/jaipur-haridwar-cab-services.html'
      }
    ]
  },
  {
    id: uuidv4(),
    heading: 'Top Train  Routes to Haridwar',
    listData: [
      {
        id: uuidv4(),
        text: 'Delhi To  Haridwar Trains',
        link: 'https://www.makemytrip.com/railways/delhi-haridwar-train-tickets.html'
      },
      {
        id: uuidv4(),
        text: 'Mumbai To  Haridwar Trains',
        link: 'https://www.makemytrip.com/railways/mumbai-haridwar-train-tickets.html'
      },
      {
        id: uuidv4(),
        text: 'Ahemdabad To  Haridwar Trains',
        link: 'https://www.makemytrip.com/railways/ahmedabad-haridwar-train-tickets.html'
      },
      {
        id: uuidv4(),
        text: 'Kolkata To  Haridwar Trains',
        link: 'https://www.makemytrip.com/railways/kolkata-haridwar-train-tickets.html'
      },
      {
        id: uuidv4(),
        text: 'Lucknow To  Haridwar Trains',
        link: 'https://www.makemytrip.com/railways/lucknow-haridwar-train-tickets.html'
      },
      {
        id: uuidv4(),
        text: 'Jaipur To  Haridwar Trains',
        link: 'https://www.makemytrip.com/railways/jaipur-haridwar-train-tickets.html'
      },
      {
        id: uuidv4(),
        text: 'Bhopal To  Haridwar Trains',
        link: 'https://www.makemytrip.com/railways/bhopal-haridwar-train-tickets.html'
      },
      {
        id: uuidv4(),
        text: 'Jammu To  Haridwar Trains',
        link: 'https://www.makemytrip.com/railways/jammu-haridwar-train-tickets.html'
      },
      {
        id: uuidv4(),
        text: 'Indoreto  Haridwar Trains',
        link: 'https://www.makemytrip.com/railways/indore-haridwar-train-tickets.html'
      }
    ]
  },
  {
    id: uuidv4(),
    heading: 'Top Bus Routes to Haridwar',
    listData: [
      {
        id: uuidv4(),
        text: 'Buses from Delhi To Haridwar',
        link: 'https://www.makemytrip.com/bus-tickets/delhi-haridwar-bus-ticket-booking.html'
      },
      {
        id: uuidv4(),
        text: 'Buses from Gurgaon To Haridwar',
        link: 'https://www.makemytrip.com/bus-tickets/gurgaon-haridwar-bus-ticket-booking.html'
      },
      {
        id: uuidv4(),
        text: 'Buses from Jaipur To Haridwar',
        link: 'https://www.makemytrip.com/bus-tickets/jaipur-haridwar-bus-ticket-booking.html'
      },
      {
        id: uuidv4(),
        text: 'Buses from Rishikesh To Haridwar',
        link: 'https://www.makemytrip.com/bus-tickets/rishikesh-haridwar-bus-ticket-booking.html'
      },
      {
        id: uuidv4(),
        text: 'Buses from Joshimath To Haridwar',
        link: 'https://www.makemytrip.com/bus-tickets/joshimath-haridwar-bus-ticket-booking.html'
      },
      {
        id: uuidv4(),
        text: 'Buses from Chadi To Haridwar',
        link: 'https://www.makemytrip.com/bus-tickets/chadi-haridwar-bus-ticket-booking.html'
      },
      {
        id: uuidv4(),
        text: 'Buses from Agra To Haridwar',
        link: 'https://www.makemytrip.com/bus-tickets/agra-haridwar-bus-ticket-booking.html'
      },
      {
        id: uuidv4(),
        text: 'Buses from Dehradun To Haridwar',
        link: 'https://www.makemytrip.com/bus-tickets/dehradun-haridwar-bus-ticket-booking.html'
      },
      {
        id: uuidv4(),
        text: 'Buses from Pushkar To Haridwar',
        link: 'https://www.makemytrip.com/bus-tickets/pushkar-haridwar-bus-ticket-booking.html'
      }
    ]
  },
  {
    id: uuidv4(),
    heading: 'Top Bus Routes to Haridwar',
    listData: [
      {
        id: uuidv4(),
        text: 'Buses from Ajmer To Haridwar',
        link: 'https://www.makemytrip.com/bus-tickets/ajmer-haridwar-bus-ticket-booking.html'
      },
      {
        id: uuidv4(),
        text: 'Buses from Lucknow To Haridwar',
        link: 'https://www.makemytrip.com/bus-tickets/lucknow-haridwar-bus-ticket-booking.html'
      },
      {
        id: uuidv4(),
        text: 'Buses from Meerut To Haridwar',
        link: 'https://www.makemytrip.com/bus-tickets/meerut-haridwar-bus-ticket-booking.html'
      },
      {
        id: uuidv4(),
        text: 'Buses from Jodhpur To Haridwar',
        link: 'https://www.makemytrip.com/bus-tickets/jodhpur-haridwar-bus-ticket-booking.html'
      }
    ]
  }
];

export const whyMMTData = [
  {
    id: uuidv4(),
    heading: 'Why MakeMyTrip?',
    description:
      'The leading player in online flight bookings in India, MakeMyTrip offers great offers, some of the lowest airfares, exclusive discounts and a seamless online booking experience. Flight, hotel and holiday bookings through the desktop or mobile site is a delightfully customer friendly experience, and with just a few clicks you can complete your booking. With features like Instant Discounts, Fare Calendar, MyRewards Program, MyWallet and many more, the overall booking experience with MakeMyTrip constantly adds value to its product and continues to offer the best to its customers.'
  },
  {
    id: uuidv4(),
    heading: 'Booking Flights with MakeMyTrip',
    description:
      "Book your flights tickets with India's leading flight booking company since the year 2000. While booking flights with MakeMyTrip, you can expect the ultimate online booking experience. With premium customer service, 24/7 dedicated helpline for support, and over 5 million delighted customers, MakeMyTrip takes great pride in enabling customer satisfaction. With a cheapest flight guarantee, book your tickets at the lowest airfares. Avail great offers, exclusive deals for loyal customers and get instant updates for your flight status and fare drops."
  },
  {
    id: uuidv4(),
    heading: 'Domestic Flights with MakeMyTrip',
    description:
      "MakeMyTrip is India's leading player for flight bookings, and have a dominant position in the domestic flights sector. With the cheapest fare guarantee, experience great value at the lowest price. Instant notifications ensure current flight status, instant fare drops, amazing discounts, instant refunds and rebook options, price comparisons and many more interesting features."
  }
];

export const importantLinksData = [
  {
    id: uuidv4(),
    iconUrl: 'kumbhMelaMmtIcon',
    heading: 'Make my trip',
    listData: [
      {
        id: uuidv4(),
        text: 'About Us',
        link: 'https://www.makemytrip.com/about-us/company_profile.php'
      },
      {
        id: uuidv4(),
        text: 'Investor Relations',
        link: 'https://investors.makemytrip.com/'
      },
      {
        id: uuidv4(),
        text: 'Testimonial',
        link: 'https://www.makemytrip.com/about-us/testimonial.do'
      },
      {
        id: uuidv4(),
        text: 'Reviews',
        link: 'https://reviews.makemytrip.com/reviews/app/landingPage.htm'
      },
      {
        id: uuidv4(),
        text: 'Careers',
        link: 'https://www.makemytrip.com/about-us/jobs.php'
      },
      {
        id: uuidv4(),
        text: 'Corporate Travel',
        link: 'https://mybiz.makemytrip.com/?intid=mmtfooter_corporatetravel'
      },
      {
        id: uuidv4(),
        text: 'Travel Guide',
        link: 'https://www.makemytrip.com/travel-guide/'
      },
      {
        id: uuidv4(),
        text: 'Blog',
        link: 'https://www.makemytrip.com/blog/?intid=mmtblog_footer'
      },
      {
        id: uuidv4(),
        text: 'Offers',
        link: 'https://www.makemytrip.com/coupons/'
      },
      {
        id: uuidv4(),
        text: 'American Express® ',
        link: 'https://www.makemytrip.com/mmtamexcard/index.html'
      },
      {
        id: uuidv4(),
        text: 'MakeMyTrip Credit Card',
        link: 'https://www.makemytrip.com/mmtamexcard/index.html'
      },
      {
        id: uuidv4(),
        text: 'Gift Vouchers',
        link: 'https://makemytrip.com/gift-cards/'
      },
      {
        id: uuidv4(),
        text: 'MakeMyTrip Coupons',
        link: 'https://www.makemytrip.com/coupons/'
      },
      {
        id: uuidv4(),
        text: 'My Trip Essentials',
        link: 'https://www.makemytrip.com/mytripessentials/index.php'
      },
      {
        id: uuidv4(),
        text: 'Deals',
        link: 'https://www.makemytrip.com/daily-deals'
      },
      {
        id: uuidv4(),
        text: 'Stories',
        link: 'https://www.makemytrip.com/blog/?intid=Blog_HomePage_Tab_Stories'
      },
      {
        id: uuidv4(),
        text: 'Trip Planner',
        link: 'https://planner.makemytrip.com/?&intid=Homepage_Tab_Inspirock'
      }
    ]
  },
  {
    id: uuidv4(),
    iconUrl: 'kumbhMelaProductOfferIcon',
    heading: 'Product Offering',
    listData: [
      {
        id: uuidv4(),
        text: 'Flights ',
        link: 'https://www.makemytrip.com/flights/'
      },
      {
        id: uuidv4(),
        text: 'Flight+Hotel Deals',
        link: 'https://www.makemytrip.com/flights-hotels'
      },
      {
        id: uuidv4(),
        text: 'International Flights',
        link: 'https://www.makemytrip.com/international-flights/'
      },
      {
        id: uuidv4(),
        text: 'Hotels',
        link: 'https://www.makemytrip.com/hotels/'
      },
      {
        id: uuidv4(),
        text: 'International Hotels',
        link: 'https://www.makemytrip.com/hotels-international/'
      },
      {
        id: uuidv4(),
        text: 'Holidays in India',
        link: 'https://www.makemytrip.com/holidays-india'
      },
      {
        id: uuidv4(),
        text: 'International Holidays',
        link: 'https://www.makemytrip.com/holidays-international'
      },
      {
        id: uuidv4(),
        text: 'Cabs',
        link: 'https://www.makemytrip.com/cabs'
      },
      {
        id: uuidv4(),
        text: 'Cheap Tickets to India',
        link: 'https://www.makemytrip.com/?ccde=us'
      },
      {
        id: uuidv4(),
        text: 'Bus Tickets',
        link: 'https://www.makemytrip.com/bus-tickets/'
      },
      {
        id: uuidv4(),
        text: 'Rail',
        link: 'https://www.makemytrip.com/railways/'
      },
      {
        id: uuidv4(),
        text: 'Route Planner',
        link: 'https://www.makemytrip.com/routeplanner/'
      },
      {
        id: uuidv4(),
        text: 'Flight Status',
        link: 'https://www.makemytrip.com/flights/flight-status.html'
      },
      {
        id: uuidv4(),
        text: 'Mobile Apps',
        link: 'https://www.makemytrip.com/new_hlp/promo_page/'
      }
    ]
  },
  {
    id: uuidv4(),
    iconUrl: 'kumbhMelaAboutSiteIcon',
    heading: 'About the Site',
    listData: [
      {
        id: uuidv4(),
        text: 'FAQs',
        link: 'https://makemytrip.custhelp.com/'
      },
      {
        id: uuidv4(),
        text: 'Complaints',
        link: 'https://support.makemytrip.com/customersupports.aspx?actiontype=COMPLAINTS'
      },
      {
        id: uuidv4(),
        text: 'Contact Us',
        link: 'https://www.makemytrip.com/support/in/eng/contact-us.php'
      },
      {
        id: uuidv4(),
        text: 'Payment Security',
        link: 'https://www.makemytrip.com/legal/payment_security.html'
      },
      {
        id: uuidv4(),
        text: 'Privacy Policy',
        link: 'https://www.makemytrip.com/legal/in/eng/privacy_policy.html'
      },
      {
        id: uuidv4(),
        text: 'User Agreement',
        link: 'https://www.makemytrip.com/legal/user_agreement.html'
      },
      {
        id: uuidv4(),
        text: 'Visa Information',
        link: 'https://www.makemytrip.com/holidays-international/visa-information.html'
      },
      {
        id: uuidv4(),
        text: 'More Offices',
        link: 'https://www.makemytrip.com/support/branch-offices.php'
      },
      {
        id: uuidv4(),
        text: 'File Rail TDR',
        link: 'https://support.makemytrip.com/customersupports.aspx?actiontype=FILETDR'
      },
      {
        id: uuidv4(),
        text: 'Make a Payment',
        link: 'https://payments.makemytrip.com/easypay/'
      },
      {
        id: uuidv4(),
        text: 'Submit Account Details',
        link: 'https://support.makemytrip.com/customersupports.aspx?actiontype=SUBMITWIRETRANSFER'
      },
      {
        id: uuidv4(),
        text: 'Report a Defect',
        link: 'https://www.makemytrip.com/pwa-hlp/mmtbb/report'
      }
    ]
  },
  {
    id: uuidv4(),
    iconUrl: 'kumbhMelaPartnerProgIcon',
    heading: 'Partner Programs',
    listData: [
      {
        id: uuidv4(),
        text: 'Our Retail Stores',
        link: 'https://www.makemytrip.com/support/branch-offices.php'
      },
      {
        id: uuidv4(),
        text: 'Franchise Program Details',
        link: 'https://www.makemytrip.com/franchisee/partner_with_us.php'
      },
      {
        id: uuidv4(),
        text: 'Foreign Exchange',
        link: 'https://www.fxkart.com/makemytrip?utm_source=MMTAFF'
      },
      {
        id: uuidv4(),
        text: 'Apollo Munich – Travel Insurance',
        link: 'https://www.makemytrip.com/mytripessentials/index.php'
      }
    ]
  },
  {
    id: uuidv4(),
    iconUrl: '',
    heading: 'More Links',
    listData: [
      {
        id: uuidv4(),
        text: 'Low Budget Holidays',
        link: 'https://www.makemytrip.com/blog/budget-holidays/?intid=mmtblog_budgetholidays_footer'
      },
      {
        id: uuidv4(),
        text: 'Delhi Mumbai Flights',
        link: 'https://www.makemytrip.com/flights/new_delhi-mumbai-cheap-airtickets.html'
      },
      {
        id: uuidv4(),
        text: 'Domestic Airlines',
        link: 'https://www.makemytrip.com/flights/airlines.html'
      },
      {
        id: uuidv4(),
        text: 'International Airlines',
        link: 'https://www.makemytrip.com/international-flights/airlines.html'
      },
      {
        id: uuidv4(),
        text: 'Indigo',
        link: 'https://www.makemytrip.com/flights/indigo-airlines.html'
      },
      {
        id: uuidv4(),
        text: 'Spicejet',
        link: 'https://www.makemytrip.com/flights/spicejet.html'
      },
      {
        id: uuidv4(),
        text: 'Jet Airways',
        link: 'https://www.makemytrip.com/flights/jet-airways.html'
      },
      {
        id: uuidv4(),
        text: 'Air Asia',
        link: 'https://www.makemytrip.com/flights/air-asia.html'
      },
      {
        id: uuidv4(),
        text: 'Delhi Hotels',
        link: 'https://www.makemytrip.com/hotels/delhi-hotels.html'
      },
      {
        id: uuidv4(),
        text: 'Mumbai Hotels',
        link: 'https://www.makemytrip.com/hotels/mumbai-hotels.html'
      },
      {
        id: uuidv4(),
        text: 'Honeymoon Packages',
        link: 'https://www.makemytrip.com/holidays-india/honeymoon-packages.html'
      },
      {
        id: uuidv4(),
        text: 'Singapore Tours',
        link: 'https://www.makemytrip.com/holidays-international/singapore-vacation-tour-packages.html'
      },
      {
        id: uuidv4(),
        text: 'Indian Railways',
        link: 'https://www.makemytrip.com/railways/indian-railways.html'
      },
      {
        id: uuidv4(),
        text: 'Kesineni Travels',
        link: 'https://www.makemytrip.com/bus-tickets/kesineni-travels-booking.html'
      },
      {
        id: uuidv4(),
        text: 'Neeta Travels',
        link: 'https://www.makemytrip.com/bus-tickets/neeta-travels-booking.html'
      },
      {
        id: uuidv4(),
        text: 'RSRTC',
        link: 'https://www.makemytrip.com/bus-tickets/rsrtc-online-booking.html'
      },
      {
        id: uuidv4(),
        text: 'Goa Packages',
        link: 'https://www.makemytrip.com/holidays-india/goa-travel-packages.html'
      },
      {
        id: uuidv4(),
        text: 'Thailand Packages',
        link: 'https://www.makemytrip.com/holidays-international/thailand-vacation-tour-packages.html'
      }
    ]
  },
  {
    id: uuidv4(),
    iconUrl: '',
    heading: 'IMPORTANT Links',
    listData: [
      {
        id: uuidv4(),
        text: 'Cheap Flights',
        link: 'https://www.makemytrip.com/flights/cheap.html'
      },
      {
        id: uuidv4(),
        text: 'Flight Status',
        link: 'https://www.makemytrip.com/flights/flight-status.html'
      },
      {
        id: uuidv4(),
        text: 'Chennai Mumbai flights',
        link: 'https://www.makemytrip.com/flights/chennai-mumbai-cheap-airtickets.html'
      },
      {
        id: uuidv4(),
        text: 'Mumbai Hyderabad flights',
        link: 'https://www.makemytrip.com/flights/mumbai-hyderabad-cheap-airtickets.html'
      },
      {
        id: uuidv4(),
        text: 'Hyderabad Bangalore flights',
        link: 'https://www.makemytrip.com/flights/hyderabad-bangalore-cheap-airtickets.html'
      },
      {
        id: uuidv4(),
        text: 'Pune Bangalore flights',
        link: 'https://www.makemytrip.com/flights/pune-bangalore-cheap-airtickets.html'
      },
      {
        id: uuidv4(),
        text: 'Mumbai Jaipur flights',
        link: 'https://www.makemytrip.com/flights/mumbai-jaipur-cheap-airtickets.html'
      },
      {
        id: uuidv4(),
        text: 'Mumbai Chandigarh flights',
        link: 'https://www.makemytrip.com/flights/mumbai-chandigarh-cheap-airtickets.html'
      },
      {
        id: uuidv4(),
        text: 'Bangalore Kolkata flights',
        link: 'https://www.makemytrip.com/flights/bangalore-kolkata-cheap-airtickets.html'
      },
      {
        id: uuidv4(),
        text: 'Hyderabad Visakhapatnam flights',
        link: 'https://www.makemytrip.com/flights/hyderabad-vishakhapatnam-cheap-airtickets.html'
      },
      {
        id: uuidv4(),
        text: 'Chandigarh Bangalore flights',
        link: 'https://www.makemytrip.com/flights/chandigarh-bangalore-cheap-airtickets.html'
      },
      {
        id: uuidv4(),
        text: 'Jaipur Mumbai flights',
        link: 'https://www.makemytrip.com/flights/jaipur-mumbai-cheap-airtickets.html'
      },
      {
        id: uuidv4(),
        text: 'Hotels in Goa',
        link: 'https://www.makemytrip.com/hotels/goa-hotels.html'
      },
      {
        id: uuidv4(),
        text: 'Hotels in Jaipur',
        link: 'https://www.makemytrip.com/hotels/jaipur-hotels.html'
      },
      {
        id: uuidv4(),
        text: 'Hotels in Ooty',
        link: 'https://www.makemytrip.com/hotels/ooty-hotels.html'
      },
      {
        id: uuidv4(),
        text: 'Kerala Packages',
        link: 'https://www.makemytrip.com/holidays-india/kerala-travel-packages.html'
      },
      {
        id: uuidv4(),
        text: 'Kashmir Packages',
        link: 'https://www.makemytrip.com/holidays-india/kashmir-travel-packages.html'
      },
      {
        id: uuidv4(),
        text: 'Ladakh Packages',
        link: 'https://www.makemytrip.com/holidays-india/ladakh-travel-packages.html'
      }
    ]
  }
];

export const moreAboutPlaceData = {
  heading: 'More about Haridwar',
  description:
    'The holy city of Haridwar translates to "Gateway to God," and the breathtaking city, replete with temples, is a magnet for religious pilgrims from all over the globe. Religious festivals hold even further draw, and tourists can’t helped but be compelled by the city’s aura of intense spirituality. Don’t miss the Har ki Pauri and the Chandi Devi Temple.',
  imageList: [
    {
      id: uuidv4(),
      imageUrl:
        'https://images.unsplash.com/photo-1511754863001-18d44abd0a93?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=2100&q=80',
      altText: 'Haridwar'
    },
    {
      id: uuidv4(),
      imageUrl:
        'https://images.unsplash.com/photo-1588750765220-50603c3c0c7a?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1934&q=80',
      altText: 'Haridwar'
    },
    {
      id: uuidv4(),
      imageUrl:
        'https://images.pexels.com/photos/2239075/pexels-photo-2239075.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
      altText: 'Haridwar'
    },
    {
      id: uuidv4(),
      imageUrl:
        'https://images.pexels.com/photos/4340435/pexels-photo-4340435.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
      altText: 'Haridwar'
    },
    {
      id: uuidv4(),
      imageUrl:
        'https://images.pexels.com/photos/6808935/pexels-photo-6808935.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
      altText: 'Haridwar'
    },
    {
      id: uuidv4(),
      imageUrl:
        'https://images.pexels.com/photos/804686/pexels-photo-804686.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
      altText: 'Haridwar'
    }
  ]
};

export const cabRouteData = [
  {
    id: uuidv4(),
    title: 'Delhi - Haridwar',
    pricePerKm: '11/km',
    cabImg: 'kumbhMelaHatchBackIcon',
    oldPrice: '3,237',
    newPrice: '2,815',
    discount: '50% off',
    cabName: 'Sedan',
    cta: 'Book Now',
    url: 'https://cabs.makemytrip.com/dt_cabsListing?fromCity=DL&toCity=XHA&tripType=OW&departDate=30-06-2021&pickupTime=10:00'
  },
  {
    id: uuidv4(),
    title: 'Dehradun - Haridwar',
    pricePerKm: '32/km',
    cabImg: 'kumbhMelaHatchBackIcon',
    oldPrice: '2,129',
    newPrice: '1,852',
    discount: '50% off',
    cabName: 'SUV',
    cta: 'Book Now',
    url: 'https://cabs.makemytrip.com/dt_cabsListing?fromCity=DED&toCity=XHA&tripType=OW&departDate=30-06-2021&pickupTime=10:00'
  },
  {
    id: uuidv4(),
    title: 'Chandigarh - Haridwar',
    pricePerKm: '14/km',
    cabImg: 'kumbhMelaHatchBackIcon',
    oldPrice: '4,226',
    newPrice: '3,675',
    discount: '50% off',
    cabName: 'Sedan',
    cta: 'Book Now',
    url: 'https://cabs.makemytrip.com/dt_cabsListing?fromCity=IXC&toCity=XHA&tripType=OW&departDate=30-06-2021&pickupTime=10:00'
  },
  {
    id: uuidv4(),
    title: 'Jaipur - Haridwar',
    pricePerKm: '13/km',
    cabImg: 'kumbhMelaHatchBackIcon',
    oldPrice: '7,252',
    newPrice: '6,252',
    discount: '50% off',
    cabName: 'Hatchback',
    cta: 'Book Now',
    url: 'https://cabs.makemytrip.com/dt_cabsListing?fromCity=JAI&toCity=XHA&tripType=OW&departDate=30-06-2021&pickupTime=10:00'
  },
  {
    id: uuidv4(),
    title: 'Noida - Haridwar',
    pricePerKm: '13/km',
    cabImg: 'kumbhMelaHatchBackIcon',
    oldPrice: '4,572',
    newPrice: '3,976',
    discount: '50% off',
    cabName: 'Sedan',
    cta: 'Book Now',
    url: 'https://cabs.makemytrip.com/dt_cabsListing?fromCity=Noida&toCity=XHA&tripType=OW&departDate=30-06-2021&pickupTime=10:00'
  },
  {
    id: uuidv4(),
    title: 'Faridabad - Haridwar',
    pricePerKm: '14/km',
    cabImg: 'kumbhMelaHatchBackIcon',
    oldPrice: '4,766',
    newPrice: '4,145',
    discount: '50% off',
    cabName: 'Sedan',
    cta: 'Book Now',
    url: 'https://cabs.makemytrip.com/dt_cabsListing?fromCity=Faridabad&toCity=XHA&tripType=OW&departDate=30-06-2021&pickupTime=10:00'
  }
];

export const busRouteData = [
  {
    id: uuidv4(),
    title: 'Delhi - Haridwar',
    travellerName: 'UPSRTC',
    busType: 'JAN RATH A/C (2+2)',
    oldPrice: '1,200',
    newPrice: '459',
    departureTime: '08:00',
    depMeridies: 'AM',
    arrivalTime: '01:00',
    arrMeridies: 'PM',
    cta: 'BOOK NOW',
    dwebUrl: 'https://www.makemytrip.com/bus-tickets/delhi-haridwar-bus-ticket-booking.html',
    mwebUrl: ''
  },
  {
    id: uuidv4(),
    title: 'Gurgaon - Haridwar',
    travellerName: 'Zingbus',
    busType: 'Bharat Benz A/C Seater (2+2)',
    oldPrice: '1,200',
    newPrice: '838',
    departureTime: '09:50',
    depMeridies: 'PM',
    arrivalTime: '04:55',
    arrMeridies: 'AM',
    cta: 'BOOK NOW',
    dwebUrl: 'https://www.makemytrip.com/bus-tickets/gurgaon-haridwar-bus-ticket-booking.html',
    mwebUrl: ''
  },
  {
    id: uuidv4(),
    title: 'Jaipur - Haridwar',
    travellerName: 'Vikas Travels Jaipur',
    busType: 'A/C Seater / Sleeper (2+1)',
    oldPrice: '1,200',
    newPrice: '800',
    departureTime: '08:15',
    depMeridies: 'PM',
    arrivalTime: '07:30',
    arrMeridies: 'AM',
    cta: 'BOOK NOW',
    dwebUrl: 'https://www.makemytrip.com/bus-tickets/jaipur-haridwar-bus-ticket-booking.html',
    mwebUrl: ''
  },
  {
    id: uuidv4(),
    title: 'Rishikesh - Haridwar',
    travellerName: 'Zingbus',
    busType: 'Bharat Benz A/C Seater (2+2)',
    oldPrice: '1,200',
    newPrice: '471',
    departureTime: '11:20',
    depMeridies: 'PM',
    arrivalTime: '11:55',
    arrMeridies: 'PM',
    cta: 'BOOK NOW',
    dwebUrl: 'https://www.makemytrip.com/bus-tickets/rishikesh-haridwar-bus-ticket-booking.html',
    mwebUrl: ''
  },
  {
    id: uuidv4(),
    title: 'Joshimath - Haridwar',
    travellerName: 'Tehri Garhwal Motor owners corporation',
    busType: 'NON A/C Seater (2+2)',
    oldPrice: '1,200',
    newPrice: '650',
    departureTime: '06:14',
    depMeridies: 'AM',
    arrivalTime: '06:00',
    arrMeridies: 'PM',
    cta: 'BOOK NOW',
    dwebUrl: 'https://www.makemytrip.com/bus-tickets/joshimath-haridwar-bus-ticket-booking.html',
    mwebUrl: ''
  },
  {
    id: uuidv4(),
    title: 'Agra - Haridwar',
    travellerName: 'UPSRTC',
    busType: 'JAN RATH A/C (2+2)',
    oldPrice: '1,200',
    newPrice: '711',
    departureTime: '04:30',
    depMeridies: 'PM',
    arrivalTime: '03:20',
    arrMeridies: 'AM',
    cta: 'BOOK NOW',
    dwebUrl: 'https://www.makemytrip.com/bus-tickets/agra-haridwar-bus-ticket-booking.html',
    mwebUrl: ''
  }
];

export const trainRouteData = [
  {
    id: uuidv4(),
    title: 'Delhi - Haridwar',
    trainName: 'SIDDHABALI SPL',
    trainId: '#04048',
    oldPrice: '120',
    newPrice: '135',
    departureTime: '07:50',
    depMeridies: 'AM',
    arrivalTime: '01:40',
    arrMeridies: 'PM',
    classType: '2S | General',
    cta: 'BOOK NOW',
    dwebUrl:
      'https://railways.makemytrip.com/railways/listing/?isSeo=true&classCode=&date=20210701&destCity=Haridwar&destStn=HW&srcCity=Delhi&srcStn=NDLS',
    mwebUrl:
      'https://rails.makemytrip.com/pwa/v2/railsListingPage?isSeo=true&from_city=Delhi&from=NDLS&to_city=Haridwar&to=HW&departure=20210701&trainNumber=04048&selectedLang=en'
  },
  {
    id: uuidv4(),
    title: 'Amritsar - Haridwar',
    trainName: 'ASR HW JAN SPL',
    trainId: '#02054',
    oldPrice: '120',
    newPrice: '195',
    departureTime: '06:50',
    depMeridies: 'AM',
    arrivalTime: '01:50',
    arrMeridies: 'PM',
    classType: '2S | General',
    cta: 'BOOK NOW',
    dwebUrl:
      'https://railways.makemytrip.com/railways/listing/?isSeo=true&classCode=&className=All%20Classes&date=20210701&destCity=Haridwar&destStn=HW&srcCity=Amritsar&srcStn=ASR',
    mwebUrl:
      'https://rails.makemytrip.com/pwa/v2/railsListingPage?isSeo=true&from_city=Amritsar&from=ASR&to_city=Haridwar&to=HW&departure=20210425&trainNumber=02054&selectedLang=en'
  },
  {
    id: uuidv4(),
    title: 'Ahmedabad - Haridwar',
    trainName: 'ADI YNRK SPECIAL',
    trainId: '#09031',
    oldPrice: '120',
    newPrice: '330',
    departureTime: '10:55',
    depMeridies: 'AM',
    arrivalTime: '11:18',
    arrMeridies: 'AM',
    classType: 'SL | General',
    cta: 'BOOK NOW',
    dwebUrl:
      'https://railways.makemytrip.com/railways/listing/?isSeo=true&classCode=&className=All%20Classes&date=20210701&destCity=Haridwar&destStn=HW&srcCity=Ahmedabad&srcStn=ADI',
    mwebUrl:
      'https://rails.makemytrip.com/pwa/v2/railsListingPage?isSeo=true&from_city=Ahmedabad&from=ADI&to_city=Haridwar&to=HW&departure=20210701&trainNumber=09031&selectedLang=en'
  },
  {
    id: uuidv4(),
    title: 'Mumbai - Haridwar',
    trainName: 'BDTS HW SPL',
    trainId: '#09019',
    oldPrice: '120',
    newPrice: '380',
    departureTime: '00:05',
    depMeridies: 'AM',
    arrivalTime: '08:20',
    arrMeridies: 'AM',
    classType: '2S | General',
    cta: 'BOOK NOW',
    dwebUrl:
      'https://railways.makemytrip.com/railways/listing/?isSeo=true&classCode=&className=All%20Classes&date=20210701&destCity=Haridwar&destStn=HW&srcCity=Mumbai&srcStn=DR',
    mwebUrl:
      'https://rails.makemytrip.com/pwa/v2/railsListingPage?isSeo=true&from_city=Mumbai&from=CSTM&to_city=Haridwar&to=HW&departure=20210701&trainNumber=09019&selectedLang=en'
  },
  {
    id: uuidv4(),
    title: 'Lucknow - Haridwar',
    trainName: 'HWH JAT SPECIAL',
    trainId: '#02331',
    oldPrice: '120',
    newPrice: '210',
    departureTime: '07:45',
    depMeridies: 'PM',
    arrivalTime: '04:15',
    arrMeridies: 'AM',
    classType: '2S | General',
    cta: 'BOOK NOW',
    dwebUrl:
      'https://railways.makemytrip.com/railways/listing/?isSeo=true&classCode=&className=All%20Classes&date=20210701&destCity=Haridwar&destStn=HW&srcCity=Lucknow&srcStn=LKO',
    mwebUrl:
      'https://rails.makemytrip.com/pwa/v2/railsListingPage?isSeo=true&from_city=Lucknow&from=LKO&to_city=Haridwar&to=HW&departure=20210701&trainNumber=02331&selectedLang=en'
  },
  {
    id: uuidv4(),
    title: 'Kolkata - Haridwar',
    trainName: 'HWH DDN SPL',
    trainId: '#08237',
    oldPrice: '120',
    newPrice: '415',
    departureTime: '01:00',
    depMeridies: 'PM',
    arrivalTime: '03:50',
    arrMeridies: 'PM',
    classType: '2S | General',
    cta: 'BOOK NOW',
    dwebUrl:
      'https://railways.makemytrip.com/railways/listing/?isSeo=true&classCode=&className=All%20Classes&date=20210701&destCity=Haridwar&destStn=HW&srcCity=Kolkata&srcStn=HWH',
    mwebUrl:
      'https://rails.makemytrip.com/pwa/v2/railsListingPage?isSeo=true&from_city=Kolkata&from=HWH&to_city=Haridwar&to=HW&departure=20210701&trainNumber=08237&selectedLang=en'
  }
];

export const flightRouteData = [
  {
    id: uuidv4(),
    flightName: 'Air India',
    flightIcon: 'kumbhMelaJetAirwaysIcon',
    oldPrice: '6,600',
    newPrice: '2,353',
    from: 'Delhi',
    to: 'Dehradun',
    departureTime: '06:20',
    depMeridies: 'AM',
    arrivalTime: '07:20',
    arrMeridies: 'AM',
    cta: 'BOOK NOW',
    url: 'https://www.makemytrip.com/flights/new_delhi-dehradun-cheap-airtickets.html'
  },
  {
    id: uuidv4(),
    flightName: 'IndiGo',
    flightIcon: 'kumbhMelaJetAirwaysIcon',
    oldPrice: '6,600',
    newPrice: '4,269',
    from: 'Mumbai',
    to: 'Dehradun',
    departureTime: '08:30',
    depMeridies: 'AM',
    arrivalTime: '03:20',
    arrMeridies: 'PM',
    cta: 'BOOK NOW',
    url: 'https://www.makemytrip.com/flights/mumbai-dehradun-cheap-airtickets.html'
  },
  {
    id: uuidv4(),
    flightName: 'IndiGo',
    flightIcon: 'kumbhMelaJetAirwaysIcon',
    oldPrice: '6,600',
    newPrice: '3,597',
    from: 'Ahmedabad',
    to: 'Dehradun',
    departureTime: '07:15',
    depMeridies: 'PM',
    arrivalTime: '07:55',
    arrMeridies: 'AM',
    cta: 'BOOK NOW',
    url: 'https://www.makemytrip.com/flights/ahmedabad-dehradun-cheap-airtickets.html'
  },
  {
    id: uuidv4(),
    flightName: 'IndiGo',
    flightIcon: 'kumbhMelaJetAirwaysIcon',
    oldPrice: '6,600',
    newPrice: '3,437',
    from: 'Jaipur',
    to: 'Dehradun',
    departureTime: '07:50',
    depMeridies: 'AM',
    arrivalTime: '03:20',
    arrMeridies: 'PM',
    cta: 'BOOK NOW',
    url: 'https://www.makemytrip.com/flights/jaipur-dehradun-cheap-airtickets.html'
  },
  {
    id: uuidv4(),
    flightName: 'Spicejet',
    flightIcon: 'kumbhMelaJetAirwaysIcon',
    oldPrice: '6,600',
    newPrice: '3,597',
    from: 'Lucknow',
    to: 'Dehradun',
    departureTime: '07:25',
    depMeridies: 'PM',
    arrivalTime: '07:55',
    arrMeridies: 'AM',
    cta: 'BOOK NOW',
    url: 'https://www.makemytrip.com/flights/lucknow-dehradun-cheap-airtickets.html'
  }
];

export const whereToStayData = {
  heading: 'Where to stay in Haridwar',
  viewAll: 'View All hotels',
  listData: [
    {
      id: uuidv4(),
      imageUrl:
        'https://r1imghtlak.mmtcdn.com/268f09ca135e11e5a12cdaf4768ad8d9.jfif?&output-quality=75&downsize=375:218&crop=375:218;0,16&output-format=jpg',
      review: '2593 Reviews',
      price: '3,196',
      hotelName: 'Hotel Le Roi, Haridwar',
      address: ' Haridwar City Railway Station',
      dwebUrl:
        'https://www.makemytrip.com/hotels/hotel-details/?hotelId=201506151420554162&mtkeys=defaultMtkey&_uCurrency=INR&checkin=04052021&checkout=04062021&city=CTXHA&cmp=SEO&country=IN&lat=29.94649&lng=78.15324&locusId=CTXHA&locusType=city&modifyDates=true&rank=2&roomStayQualifier=1e0e&searchText=Haridwar&seoReq=1615453500043',
      mwebUrl: ''
    },
    {
      id: uuidv4(),
      imageUrl:
        'https://r1imghtlak.mmtcdn.com/bd098c14f60e11e7b54302155a238f12.jpg?&output-quality=75&downsize=375:218&crop=375:218;0,23&output-format=jpg',
      review: '547 Reviews',
      price: '4,700',
      hotelName: 'Fortune Park Haridwar-Member ITC Hotel Group',
      address: 'Plot No. 296/2 NH-58 Bahadrabad, Haridwar',
      dwebUrl:
        'https://www.makemytrip.com/hotels/hotel-details/?hotelId=201801171831093575&mtkeys=defaultMtkey&_uCurrency=INR&checkin=04052021&checkout=04062021&city=CTXHA&cmp=SEO&country=IN&lat=29.91896&lng=78.05821&locusId=CTXHA&locusType=city&modifyDates=true&rank=3&roomStayQualifier=1e0e&searchText=Haridwar&seoReq=1615453500043',
      mwebUrl: ''
    },
    {
      id: uuidv4(),
      imageUrl:
        'https://r1imghtlak.mmtcdn.com/acec7846e96a11e883240242ac110002.jpg?&output-quality=75&downsize=375:218&crop=375:218;0,16&output-format=jpg',
      review: '578 Reviews',
      price: '4,378',
      hotelName: 'Regenta Orkos- Royal Orchid Hotels',
      address: 'Haridwar Rishikesh Highway,Haripur Kalan Motichur',
      dwebUrl:
        'https://www.makemytrip.com/hotels/hotel-details/?hotelId=2015071314154570&mtkeys=defaultMtkey&_uCurrency=INR&checkin=04052021&checkout=04062021&city=CTXHA&cmp=SEO&country=IN&lat=30.00651&lng=78.18995&locusId=CTXHA&locusType=city&modifyDates=true&rank=4&roomStayQualifier=1e0e&searchText=Haridwar&seoReq=1615453500043',
      mwebUrl: ''
    },
    {
      id: uuidv4(),
      imageUrl:
        'https://r1imghtlak.mmtcdn.com/ca6fe56a1d4f11e9b6220242ac110002.jfif?&output-quality=75&downsize=375:218&crop=375:218;0,15&output-format=jpg',
      review: '839 Reviews',
      price: '2,557',
      hotelName: 'Ambrosia Sarovar Portico',
      address: 'NH -334, 12th Milestone Badheri',
      dwebUrl:
        'https://www.makemytrip.com/hotels/hotel-details/?hotelId=201004191239369005&mtkeys=defaultMtkey&_uCurrency=INR&checkin=04052021&checkout=04062021&city=CTXHA&cmp=SEO&country=IN&lat=29.90083&lng=77.98866&locusId=CTXHA&locusType=city&modifyDates=true&rank=6&roomStayQualifier=1e0e&searchText=Haridwar&seoReq=1615453500043',
      mwebUrl: ''
    },
    {
      id: uuidv4(),
      imageUrl:
        'https://r1imghtlak.mmtcdn.com/c29b20b66c5c11e798f90a4cef95d023.jpg?&output-quality=75&downsize=375:218&crop=375:218;0,16&output-format=jpg',
      review: '1077 Reviews',
      price: '1,077',
      hotelName: 'Alpana Hotel',
      address: '43-44, Ram Ghat, Haridwar',
      dwebUrl:
        'https://www.makemytrip.com/hotels/hotel-details/?hotelId=200701191912519885&mtkeys=defaultMtkey&_uCurrency=INR&checkin=04052021&checkout=04062021&city=CTXHA&cmp=SEO&country=IN&lat=29.95214&lng=78.16586&locusId=CTXHA&locusType=city&modifyDates=true&rank=7&roomStayQualifier=1e0e&searchText=Haridwar&seoReq=1615453500043',
      mwebUrl: ''
    }
  ]
};
